import React, { useEffect, useState } from 'react';

import CustomLoading from '../../../util_components/custom_loading';
import DataTable from '../shared/data_table';
import LoadFailed from '../shared/load_failed';
import { TOTALS_ROUNDING_NOTE } from '../format';
import { fetch_policy_rules } from './api';
import { RULES_NOTICE, rules_error_view, rules_view } from './adapters';

/*
 * PROD-7828 R10 — calculation-rules page (/teacher-payments/rules, a hidden tab). Read-only by
 * decision (D100/2.6): no inputs or actions in the tables, and the notice says so up front.
 * Not month-scoped and never blocked by D97 (R10-C13). props: on_error(e, fallback).
 */
const COLUMNS = [
  {
    key: 'policy_key',
    label: 'Rule',
    hideInCard: true,
    render: (r) => <span className="tp-mono">{r.policy_key}</span>
  },
  { key: 'value', label: 'Value', render: (r) => <span className="tp-strong">{r.value}</span> },
  { key: 'unit', label: 'Unit' },
  { key: 'description', label: 'What it does' },
  { key: 'prd_ref', label: 'PRD' },
  { key: 'decision_ref', label: 'Decision' },
  { key: 'effective_from', label: 'Effective from' },
  { key: 'updated_by', label: 'Changed by' }
];

const CalculationRulesTab = ({ on_error }) => {
  const [status, setStatus] = useState('loading'); // loading | ready | error
  const [view, setView] = useState({ notice: RULES_NOTICE, groups: [] });
  const [error_text, setErrorText] = useState('');
  const [rev, setRev] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setStatus('loading');
    setErrorText('');
    fetch_policy_rules()
      .then((data) => {
        if (cancelled) return;
        setView(rules_view(data));
        setStatus('ready');
      })
      .catch((e) => {
        if (cancelled) return;
        const fallback = 'Could not load the calculation rules.';
        const v = rules_error_view(e, fallback);
        if (v.kind === 'permission') on_error(e, fallback);
        else setErrorText(v.text);
        setStatus('error');
      });
    return () => {
      cancelled = true;
    };
  }, [rev, on_error]);

  return (
    <div>
      <div className="tp-card-hd">
        <span className="tp-card-hd-title">Calculation rules</span>
        <span className="tp-card-hd-sub">The values the payment engine uses today</span>
      </div>
      <div className="tp-banner tp-banner-info" role="note">
        {view.notice}
      </div>
      <p className="tp-rp-note">{TOTALS_ROUNDING_NOTE}</p>

      {status === 'loading' ? <CustomLoading /> : null}
      {status === 'error' && error_text ? (
        <LoadFailed text={error_text} on_retry={() => setRev((r) => r + 1)} />
      ) : null}
      {status === 'ready' && !view.groups.length ? (
        <div className="tp-empty">No calculation rules were returned.</div>
      ) : null}
      {status === 'ready'
        ? view.groups.map((g) => (
            <section key={g.key} className="tp-card" aria-labelledby={`tp-rules-${g.key}`}>
              <div className="tp-card-hd">
                <span className="tp-card-hd-title" id={`tp-rules-${g.key}`}>
                  {g.label}
                </span>
              </div>
              <DataTable
                columns={COLUMNS}
                rows={g.rows}
                rowKey={(r) => r.policy_key}
                cardTitle={(r) => <span className="tp-mono">{r.policy_key}</span>}
              />
            </section>
          ))
        : null}
    </div>
  );
};

export default CalculationRulesTab;
